import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import type { RelatorioPreview } from '../tipos/ajudaCusto'
import { formatarData, formatarMoeda } from '../utils'

/**
 * Gera PDF da prévia de pagamento de Bônus Presencial:
 * pessoas a pagar, quantidade de dias, valor do dia, total por pessoa,
 * total geral e período.
 */
export function exportarPreviaPagamentoPdf(preview: RelatorioPreview): void {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

  const periodo = `${formatarData(preview.dataInicio)} — ${formatarData(preview.dataFim)}`

  doc.setFontSize(14)
  doc.text('Bônus Presencial — Pagamento', 14, 14)
  doc.setFontSize(10)
  doc.text(`Período: ${periodo}`, 14, 21)

  const head = [['Pessoa', 'Dias', 'Valor do dia', 'Total']]

  const body = preview.pessoas.map((p) => {
    const valorDia = p.quantidadeDias > 0 ? p.valorTotal / p.quantidadeDias : 0
    return [
      p.pessoaNome,
      String(p.quantidadeDias),
      formatarMoeda(valorDia),
      formatarMoeda(p.valorTotal),
    ]
  })

  body.push(['Total geral', String(preview.quantidadeDias), '', formatarMoeda(preview.valorTotalGeral)])

  autoTable(doc, {
    head,
    body,
    startY: 26,
    styles: { fontSize: 9 },
    headStyles: { fillColor: [70, 79, 229] },
    theme: 'grid',
    columnStyles: {
      1: { halign: 'center' },
      2: { halign: 'right' },
      3: { halign: 'right' },
    },
    didParseCell: (data) => {
      if (data.section !== 'body') return
      const idx = data.row.index
      if (idx === preview.pessoas.length) {
        data.cell.styles.fillColor = [229, 231, 235]
        data.cell.styles.fontStyle = 'bold'
        return
      }
      if (idx % 2 === 0) data.cell.styles.fillColor = [249, 250, 251]
    },
  })

  doc.save(`bonus-presencial_${preview.dataInicio}_a_${preview.dataFim}.pdf`)
}
